import { render, staticRenderFns } from "./szjc-folder.vue?vue&type=template&id=62bb7360&"
import script from "./szjc-folder.vue?vue&type=script&lang=ts&"
export * from "./szjc-folder.vue?vue&type=script&lang=ts&"
import style0 from "./szjc-folder.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports